import { IComponentOptions } from "angular";
import { MachineConfigurationTypeSubmitOptionsModalServiceComponentController } from "./controller";

export const vsComponentName =
  "machineConfigurationTypeSubmitOptionsModalServiceComponent";

export const machineConfigurationTypeSubmitOptionsModalServiceComponentOptions: IComponentOptions =
  {
    controller:
      MachineConfigurationTypeSubmitOptionsModalServiceComponentController,
    controllerAs: "modalController",
    template: require("!html-loader!./index.html").default,
    bindings: {
      modalInstance: "<",
    },
  };
